export const DESTINATIONS = {
  today: {
    key: "today",
    label: "Today",
    path: "/",
  },
  sprint: {
    key: "sprint",
    label: "Accountability",
    path: "/accountability",
  },
  updates: {
    key: "updates",
    label: "Activity",
    path: "/activity",
  },
  connections: {
    key: "connections",
    label: "People",
    path: "/connections",
  },
  plan: {
    key: "plan",
    label: "Plan",
    path: "/plan",
  },
  intelligence: {
    key: "intelligence",
    label: "Insights",
    path: "/intelligence",
  },
};

export function getDestinationLabel(key, fallback = "") {
  return DESTINATIONS[key]?.label || fallback;
}
